<h2 class="m-b-0" mat-dialog-title>{{FullName}}</h2>
<div class="m-b-7 dateC m-l-10 ">{{DateOfLeave}}</div>

<div mat-dialog-content id="baja-edit-card">
    <form class="form" [formGroup]="LeaveFrom" role="form" autocomplete="off">
        <div class="fuse-card auto-width m-b-5 mat-elevation-z2 p-0 acuation-card-border t-m-2 m-0-p">
            <div class="m-b-7">
                <label class="b-t-l">Datos de Baja</label>
            </div>

            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget" fxFlex="100" fxFlex.gt-sm="35">
                    <div class="m-r-10">

                        <mat-label>Fecha Baja</mat-label>
                        <mat-form-field class="w-110 minwidth100" floatLabel="always">
                            <input formControlName="leaveDate" matInput [matDatepicker]="leaveDate"
                                placeholder="" (click)="leaveDate.open()">
                            <mat-datepicker-toggle matSuffix [for]="leaveDate"></mat-datepicker-toggle>
                            <mat-datepicker #leaveDate></mat-datepicker>
                        </mat-form-field>
                        <div class="m-t--5"
                            *ngIf="((LeaveFrom.get('leaveDate').dirty || !LeaveFrom.get('leaveDate').touched ) && LeaveFrom.get('leaveDate').invalid) || LeaveFrom.errors">
                            <span *ngIf="LeaveFrom.get('leaveDate').errors?.NoFutureDate" class="validation-span">
                                La fecha de baja no puede ser posterior a hoy
                            </span>
                            <span *ngIf="LeaveFrom.get('leaveDate').errors?.required" class="validation-span">
                                Obligatorio
                            </span>
                            <span *ngIf="LeaveFrom.get('leaveDate').errors?.SameLeaveDateExists"
                                class="validation-span">
                                Ya existe otra baja de este trabajador con la fecha especificada
                            </span>
                            <span *ngIf="LeaveFrom.get('leaveDate').errors?.LeaveNotAfterLastDischarge"
                                class="validation-span">
                                La fecha de baja debe ser superior a la fecha de la última alta
                            </span>
                            <span *ngIf="LeaveFrom.get('leaveDate').errors?.LeavePeriodConflict"
                                class="validation-span">
                                La baja se solapa con otra del mismo trabajador
                            </span>
                        </div>
                    </div>
                </div>
                <div class="widget" fxFlex="100" fxFlex.gt-sm="35">
                    <div class="m-r-10">
                        <mat-label>Fecha Alta</mat-label>

                        <mat-form-field class="w-110 minwidth100" floatLabel="always">
                            <input formControlName="dischargeDate" matInput [matDatepicker]="dischargeDate"
                                placeholder="" (dateChange)="OnDischargeDateSelect('change', $event)"
                                (click)="dischargeDate.open()" [readonly]="FPADisabled">
                            <mat-datepicker-toggle matSuffix [for]="dischargeDate"></mat-datepicker-toggle>
                            <mat-datepicker #dischargeDate></mat-datepicker>
                        </mat-form-field>
                        <div class="m-t--5"
                            *ngIf="((LeaveFrom.get('dischargeDate').dirty || LeaveFrom.get('dischargeDate').touched) && LeaveFrom.get('dischargeDate').invalid) || LeaveFrom.errors">
                            <span *ngIf="LeaveFrom.get('dischargeDate').errors?.NoFutureDate" class="validation-span">
                                La fecha de alta no puede ser posterior a hoy
                            </span>
                            <span *ngIf="LeaveFrom.get('dischargeDate').errors?.NoEarlyDischargedDateOverLeaveDate"
                                class="validation-span">
                                La fecha de alta no puede ser anterior a la fecha de baja
                            </span>
                            <span *ngIf="LeaveFrom.errors?.NoHigherDischargedDateOverCommunicationDate"
                                class="validation-span">
                                El aviso de alta no puede ser anterior a la fecha de alta
                            </span>
                            <span *ngIf="LeaveFrom.get('dischargeDate').errors?.LeavePeriodConflict"
                                class="validation-span">
                                La baja se solapa con otra del mismo trabajador
                            </span>
                            <span *ngIf="LeaveFrom.get('dischargeDate').errors?.HasAnotherOpenLeave"
                                class="validation-span">
                                Ya tiene una baja activa
                            </span>
                        </div>
                    </div>
                </div>
                <div class="widget" fxFlex="100" fxFlex.gt-sm="35">
                    <div class="m-r-10">
                        <mat-label>Aviso de Baja</mat-label>

                        <mat-form-field class="w-110 minwidth100" floatLabel="always">
                            <input formControlName="leaveCommunication" matInput [matDatepicker]="leaveCommunication"
                                placeholder="" (click)="leaveCommunication.open()">
                            <mat-datepicker-toggle matSuffix [for]="leaveCommunication"></mat-datepicker-toggle>
                            <mat-datepicker #leaveCommunication></mat-datepicker>
                        </mat-form-field>
                        <div class="m-t--5"
                            *ngIf="((LeaveFrom.get('leaveCommunication').dirty || !LeaveFrom.get('leaveCommunication').touched) && LeaveFrom.get('leaveCommunication').invalid) || LeaveFrom.errors">
                            <span *ngIf="LeaveFrom.get('leaveCommunication').errors?.NoFutureDate"
                                class="validation-span ">El
                                aviso de baja no puede ser posterior a hoy</span>
                            <span *ngIf="LeaveFrom.errors?.NoEarlyCommunicationDateOverLeaveDate"
                                class="validation-span">El aviso de baja no puede ser anterior a la fecha de baja</span>
                        </div>
                    </div>
                </div>
                <div class="widget" fxFlex="100" fxFlex.gt-sm="35">
                    <div class="m-r-10">
                        <mat-label>Aviso de Alta</mat-label>

                        <mat-form-field class="w-110 minwidth100" floatLabel="always">
                            <input formControlName="dischargeCommunication" matInput
                                [matDatepicker]="dischargeCommunication" placeholder=""
                                (click)="dischargeCommunication.open()">
                            <mat-datepicker-toggle matSuffix [for]="dischargeCommunication"></mat-datepicker-toggle>
                            <mat-datepicker #dischargeCommunication></mat-datepicker>
                        </mat-form-field>
                        <div class="m-t--5"
                            *ngIf="((LeaveFrom.get('dischargeCommunication').dirty || !LeaveFrom.get('dischargeCommunication').touched ) && LeaveFrom.get('dischargeCommunication').invalid) || LeaveFrom.errors">
                            <span *ngIf="LeaveFrom.get('dischargeCommunication').errors?.NoFutureDate"
                                class="validation-span ">El
                                aviso de alta no puede ser posterior a hoy</span>
                            <span *ngIf="LeaveFrom.errors?.NoHigherDischargedDateOverCommunicationDate"
                                class="validation-span">
                                El aviso de alta no puede ser anterior a la fecha de alta
                            </span>
                        </div>
                    </div>
                </div>

                

            </div>
            
            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget m-t-15 m-l-10" fxFlex="100" fxFlex.gt-sm="20">
                        <mat-checkbox formControlName="relapse" id="chkbx">Recaída</mat-checkbox>
                    </div>
                <div class="widget" fxFlex="100" fxFlex.gt-sm="20">   
                    <div class="m-r-10">
                        <mat-form-field class="w-120" floatLabel="always">
                        <mat-label>Referencia de la baja</mat-label>
                        <input matInput formControlName="leaveRef" (ngModelChange)="SetLeaveRef($event)" />
                        </mat-form-field>
                    </div>
                </div>
            
            </div>

            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" class="m-t-10">
                <div class="widget" fxFlex="100" fxFlex.gt-sm="100">
                    <div class="m-r-10">
                        <mat-form-field class="w100" floatLabel="always">
                            <mat-label>Médico</mat-label>
                            <mat-select  panelClass="cus-search-select" formControlName="medicoId">
                                <input type="text" autocomplete="off" matInput placeholder="búsqueda" #medicoSelect
                                        (input)="SearchDoctors()" />
                                        
                                    <div class="search-options">
                                        <mat-option *ngFor="let medico of _medicoList" [value]="medico.value">
                                            {{medico.viewValue}}
                                        </mat-option>
                                    </div>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>

        </div>

        <div class="fuse-card auto-width m-b-5 mat-elevation-z2 p-0 acuation-card-border t-m-2 m-0-p">
            <div class="m-b-7">
                <label class="b-t-l">Diagnóstico</label>
            </div>
            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget ">
                    <mat-form-field floatLabel="always">
                        <input matInput placeholder="Código" formControlName="diagCode">
                    </mat-form-field>
                    <!-- <mat-error class="m-t--5"
                        *ngIf="(LeaveFrom.get('diagCode').dirty || !LeaveFrom.get('diagCode').touched ) && LeaveFrom.get('diagCode').invalid">
                        <span *ngIf="LeaveFrom.get('diagCode').errors.required"
                            class="validation-span">Obligatorio</span>
                    </mat-error> -->
                </div>
                <div>
                    <button #diagnosisPickButton class="m-r-10 search-icon-margin" mat-icon-button
                        (click)="OnDiagnosisPick()" tabindex="-1">
                        <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19">search</mat-icon>
                    </button>
                </div>
            </div>
            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget" fxFlex="100" fxFlex.gt-sm="85">
                    <mat-form-field class="example-full-width w-90" floatLabel="always">
                        <textarea matInput placeholder="Descripción" formControlName="diagDesc"></textarea>
                    </mat-form-field>
                    <span class="flex-baja-edit m-l-10">
                        <mat-icon *ngIf="InvalidDiagnosisCode" class="mat-icon material-icons f-s-19" color="warn">close
                        </mat-icon>
                        <mat-icon *ngIf="DiagCodValidated" class="mat-icon material-icons f-s-19" color="accent">check
                        </mat-icon>
                        <mat-progress-spinner *ngIf="DiagCodeValidating" [diameter]="20" color="accent"
                            mode="indeterminate">
                        </mat-progress-spinner>
                    </span>
                </div>
                <div class="widget m-t-40" fxFlex="100" fxFlex.gt-sm="15" *ngIf="StandardEstimatedTime">
                    <strong>T.E. : {{StandardEstimatedTime}} <span *ngIf="StandardEstimatedTime">Dias</span></strong>
                </div>
            </div>

            <div>

                <mat-checkbox class="m-r-20" formControlName="acute">Agudo</mat-checkbox>

                <mat-checkbox class="m-r-20" formControlName="chronical">Crónico</mat-checkbox>

                <mat-checkbox class="m-r-20" formControlName="surgery">Int. Quirúrgica</mat-checkbox>

                <mat-checkbox formControlName="pregned" *ngIf="IsWoman">Embarazada</mat-checkbox>

            </div>

        </div>

        <div class="fuse-card auto-width m-b-5 mat-elevation-z2 p-0 acuation-card-border t-m-2 m-0-p">
            <div class="m-b-7">
                <label class="b-t-l">Pronóstico</label>
            </div>

            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget" fxFlex="100" fxFlex.gt-sm="50">
                    <div class="m-r-10">
                        <mat-form-field class="w-120" floatLabel="always">
                            <input formControlName="expectedDischargeDate" matInput [matDatepicker]="efpa"
                                placeholder="FPA" (click)="efpa.open()">
                            <mat-datepicker-toggle matSuffix [for]="efpa"></mat-datepicker-toggle>
                            <mat-datepicker #efpa></mat-datepicker>
                        </mat-form-field>
                        <div class="m-t--5"
                            *ngIf="(LeaveFrom.get('expectedDischargeDate').dirty || LeaveFrom.get('expectedDischargeDate').touched )&& LeaveFrom.get('expectedDischargeDate').invalid">
                            <span
                                *ngIf="LeaveFrom.get('expectedDischargeDate').errors.NoEarlyExpectedDischargedDateOverDischargedDate"
                                class="validation-span">La fecha prevista de alta no puede ser inferior al día de hoy</span>
                            <span
                                *ngIf="LeaveFrom.get('expectedDischargeDate').errors.NoExceedingExpectedDischargedDate"
                                class="validation-span">La fecha prevista de alta no puede exceder en 545 días a la fecha de baja </span>
                            <span *ngIf="LeaveFrom.get('expectedDischargeDate').errors.required"
                                class="validation-span">Obligatorio</span>
                        </div>
                    </div>
                </div>
                <div class="widget" fxFlex="100" fxFlex.gt-sm="50">

                    <div class="m-r-10">
                        <mat-form-field class="w100" floatLabel="always">
                            <mat-label>Riesgo Psicosocial</mat-label>
                            <mat-select formControlName="psychoSocialRisk">
                                <mat-option *ngFor="let resigoPsi of RiesgoPsicosocial" [value]="resigoPsi.value">
                                    {{resigoPsi.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget" fxFlex="100" fxFlex.gt-sm="50">
                    <div class="m-r-10">
                        <mat-form-field class="w100" floatLabel="always">
                            <mat-label>Justificada</mat-label>
                            <mat-select formControlName="justified">
                                <mat-option *ngFor="let justificada of Justificada" [value]="justificada.value">
                                    {{justificada.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="widget" fxFlex="100" fxFlex.gt-sm="50">
                    <div class="m-r-10">
                        <mat-form-field class="w100" floatLabel="always">
                            <mat-label>Actitud</mat-label>
                            <mat-select formControlName="attitude">
                                <mat-option *ngFor="let actitud of Actitud" [value]="actitud.value">
                                    {{actitud.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>

        </div>
    </form>
</div>
<mat-progress-bar class="m-t-15" mode="indeterminate" *ngIf="IsSaving"></mat-progress-bar>
<div class="text-a-r p-t-10">
    <button class="m-r-15" mat-raised-button color="accent" (click)="UpdateLeave()" [disabled]="SaveDisabled"
        #updateButton>Guardar</button>
    <button mat-raised-button color="warn" (click)="Cancel()">Cancelar</button>
</div>